export default __webpack_public_path__ + "static/media/resume.18b2f79d.jpg";